import { BaseRequestModel } from '../../base/base.request.model';

export class GetParentalControlLevelsReqMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetParentalControlLevelsReqMessage!: GetParentalControlLevelReqModel;
}
class GetParentalControlLevelReqModel extends BaseRequestModel {
  //paymentID!: string;
}
